<template>
    <div class="home-page">
      <div class="header-bgfff bgfff">
        <Header></Header>
        <div class="nav-list ac">
          <div class="back" @click="back" style="margin-top: 0px;margin-left: -60px;">
            <img width="40" src="../../static/images/back2.png" />
          </div>
          <div class="nav-li" v-for="(item,index) in typeList" @click="getToNav(item)" :class="{'active':item.id==type}">
            {{item.title}}
          </div>
        </div>
      </div>
		<div class="">
      <div class="content crfff ac por">
        <div class="sentences-content">
          <div class="sentences-type" v-for="(item,index) in list" @click="getToDetail(item)">
            <img :src="item.image">
            <div class="">
              <div class="block2-font ac">
                <div class="fw7">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
		</div>
    <div class="ac mt50">
      <button style="padding: 30px 40px;width: 320px;"
        class="button pre-button font-family"
        @click="back"
      >{{$t('back')}}</button>
    </div>
	</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        list:[],
        typeList:[],
        type:''
      }
    },
	created(){
    this.getType();
	},
    methods: {
      back(){
      	this.$router.push({path:'/'});
      },
      getToDetail(item){
        this.$router.push({path:'/Sentences300Detail',query: {theme_id:item.id,type_id:this.type}});
      },
      getToNav(item){
        this.type = item.id
        this.getList();
      },
      getType(){
        let that = this
        that.$parent.loadModal(true);
        that.$api.post('/api/study1000/get_module',null,r =>{
          that.$parent.returnCode(r,function(){
            that.typeList = r.data
            that.type = r.data[0].id
            that.getList()
            that.$parent.loadModal(false);
          })
        })
      },
      getList(){
        let that = this
        let data = {
          "module_id":this.type
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/study1000/get_theme',data,r =>{
          that.$parent.returnCode(r,function(){
            that.list = r.data
            that.$parent.loadModal(false);
          })
        })
      },
	}
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/Sentences300.vue